import React, { useEffect, useRef } from 'react';

interface IModalProps {
  children?: React.ReactNode;
  onClose: () => void;
  id?: string;
}

const Modal: React.SFC<IModalProps> = ({
  children,
  onClose,
  id,
}) => {
  useEffect(() => {
    document.body.classList.add('modal-open');
    // document.addEventListener("click", handleClickOutside, false);
    // TODO: calculate scrollbar width and add padding with this size to <body>
    return () => {
      document.body.classList.remove('modal-open');
      // document.removeEventListener("click", handleClickOutside, false);
    }
  }, []);

  const wrapperRef= useRef<HTMLDivElement>(null);

  // const handleClickOutside = (event: any) => {
  //   if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
  //     onClose();
  //   }
  // };

  return(
    <React.Fragment>
      <div className="modal fade show" role="dialog" style={{ display: 'block'}} id={id}>
        <div className="modal-dialog modal-lg" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <button onClick={onClose} type="button" className="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fillRule="evenodd" clipRule="evenodd" d="M12.377 10.0001L19.5077 2.86931C20.1641 2.21291 20.1641 1.14869 19.5077 0.492389C18.8513 -0.164005 17.7872 -0.164005 17.1308 0.492389L9.99999 7.62323L2.86914 0.492296C2.21275 -0.164099 1.14862 -0.164099 0.492225 0.492296C-0.164075 1.14869 -0.164075 2.21291 0.492225 2.86921L7.62306 9.99996L0.492225 17.1308C-0.164075 17.7872 -0.164075 18.8514 0.492225 19.5077C1.14862 20.1641 2.21275 20.1641 2.86914 19.5077L9.99999 12.3769L17.1308 19.5077C17.7871 20.1641 18.8513 20.1641 19.5077 19.5077C20.1641 18.8513 20.1641 17.7872 19.5077 17.1308L12.377 10.0001Z" fill="white"/>
                  </svg>
                </span>
              </button>
            </div>
            <div className="modal-body">
              {children}
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show" />
    </React.Fragment>
  );
};

export default Modal;
